import React from "react";
import { useLanguagesContext, useNavbarContext } from "hooks/useContextAll";

const LanguagesList = (props) => {
    const languageContext = useLanguagesContext();
    const navbarContext = useNavbarContext();

    const languagesItems = [
        { text: "English", short: "en" },
        { text: "עברית", short: "he" },
        { text: "العربية", short: "ar" },
    ];

    return (
        <ul className="languages-list animate-fade-up">
            {languagesItems.map((item, idx) => {
                return (
                    <li className="languages-item" key={`language-item-${idx}`}>
                        <button
                            className={`font-${item.short} ${languageContext.language === item.short ? 'active' : ''}`}
                            onClick={() => {
                                props.setLanguagesList(false);
                                languageContext.handleLanguage(item.short);
                                navbarContext.handleNavbarDeactive();
                            }}
                        >
                            {item.text}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};

export default LanguagesList;
